module.exports = __webpack_public_path__ + "img/国际之声@2x.095fb07d.png";